// extracted by mini-css-extract-plugin
export var table = "_xv-0";